import { WhiteLabelTheme } from "../whiteLabelTheme";
import { fourSeasonTheme } from "./fourSeason";

/**
 * Registry of white-label report themes, keyed by data.customType.
 *
 * Adding a client is one theme file plus one line here — no component or report
 * shell changes. This is why "fourSeason" never appears as a string literal in
 * ReportRMR.tsx.
 */
export const WHITE_LABEL_THEMES: Record<string, WhiteLabelTheme> = {
  [fourSeasonTheme.customType]: fourSeasonTheme,
};

export const getWhiteLabelTheme = (
  customType?: string
): WhiteLabelTheme | undefined =>
  customType ? WHITE_LABEL_THEMES[customType] : undefined;
